exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MoviesDetail {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.MoviesDetail__header {\n  width: 100%;\n  margin-bottom: 0.5rem;\n}\n\n.MoviesDetail__header > h2 {\n  margin-bottom: 0.5rem;\n}\n\n.MoviesDetail__header > div {\n  font-size: 0.9rem;\n  color: #888;\n}\n\n.MoviesDetail__img,\n.MoviesDetail__content {\n  width: 50%;\n}\n\n.MoviesDetail__img img {\n  width: 100%;\n}\n\n.MoviesDetail__content {\n  width: calc(50% - 1rem);\n  padding-left: 1rem;\n  line-height: 1.3rem;\n}\n\n.MoviesDetail__content > div {\n  margin-bottom: 0.4rem;\n}", ""]);

// exports
